
const digest = '545e1b9ce2b9d6e22e20e341d97813f6b423a995262dfa6f08846889af439544';
const classes = {"wrapper":"_wrapper_wf3qq_1","remember":"_remember_wf3qq_6","controls":"_controls_wf3qq_11"};
const css = `._wrapper_wf3qq_1 {
  border: 1px solid #eaedf3;
  padding: 24px 12px;
  overflow-x: hidden;
}
._wrapper_wf3qq_1 ._remember_wf3qq_6 {
  display: flex;
  flex-direction: row;
  gap: 5px;
}
._wrapper_wf3qq_1 ._controls_wf3qq_11 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  margin-top: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  